import React, { createContext } from "react";
const printContext = createContext({ nodeRef: null });
const PrintContextProvider = ({ children, nodeRef }) => {
    return (React.createElement(printContext.Provider, { value: { nodeRef } }, children));
};
export { printContext, PrintContextProvider };
